/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/EditAutomation/PreUpdate/Content/Removed/Content"
  
}) {
let constantData = '•'
let automationUpdateImpactRemovedValueData = fromData.useDataValue({ viewPath,
context: 'automation',
path: 'update_impact.removed',
})
let constantData1 = 'reminders will be removed'
let aggregateData = fromAggregate.join(constantData, automationUpdateImpactRemovedValueData, constantData1)
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="'•'"
 data="automation.update_impact.removed"
 data="'reminders will be removed'"
 aggregate="/Data/aggregate.js join"
 text={aggregateData}
/>
{children}
</React.Fragment>)
}